import {Directive, ElementRef, Input, OnInit, Renderer2} from '@angular/core';

@Directive({
  selector: '[appDynamicCSSProperties]',
  standalone: true
})
export class DynamicCSSPropertiesDirective implements OnInit {
  @Input() propertyConfig: {[key: string]: string};

  constructor(
    private renderer: Renderer2,
    private el: ElementRef
  ) {}

  ngOnInit() {
    this.setCSSProperties();
  }

  private setCSSProperties(): void {
    const icon = this.el.nativeElement;

    for (const property of Object.keys(this.propertyConfig)) {
      icon.style.setProperty(property, this.propertyConfig[property]);
    }
  }
}
